const supported = new Set(["fr", "en", "he", "it", "pt", "ru", "de", "es", "el", "ro"])

export function browserLanguageId(tag) {
    const code = String(tag || "").split("-")[0].trim().toLowerCase()
    return code === "el" ? "gr" : code
}

export function languageId(lang) {
    const raw = typeof lang === "string" ? lang : lang?.value || lang?.id || "fr"
    const code = browserLanguageId(raw)
    const standard = code === "gr" ? "el" : code
    return supported.has(standard) ? (standard === "el" ? "gr" : standard) : "fr"
}

export function localeCode(lang) {
    const code = languageId(lang)
    const standard = code === "gr" ? "el" : code
    return supported.has(standard) ? standard : "fr"
}

export function ogLocale(lang) {
    const code = localeCode(lang)
    return ({fr: "fr_FR", en: "en_US", he: "he_IL", it: "it_IT", pt: "pt_PT", ru: "ru_RU", de: "de_DE", es: "es_ES", el: "el_GR", ro: "ro_RO"})[code]
}
